function About() {
  return (
    <div className="about">
      <h4 className="section-title"></h4>
      <p className="section-content"></p>
    </div>
  );
}
export default About;
